import { get } from 'helpers/api';

export function getProjectDetails(dealRoomId) {
  return get(`/deal_rooms/deal_rooms/${dealRoomId}/project`);
}

export function getEntryActivity(entryId) {
  return get(`/deal_rooms/entries/${entryId}/activity`);
}
